module.exports = __webpack_public_path__ + "media/start.7ef96046.wav";